<template>
  <div>
    <v-select
      v-if="isMobile"
      v-model="selectedTab"
      :items="tabs"
      :item-text="(item) => `${prettyTab(item)}`"
      @change="updateTab(selectedTab)"
      attach
      filled
      outlined
      style="margin: 1em; margin-bottom: -1em">
      <template v-slot:selection="{ item }">
        {{ prettyTab(item) }}
      </template>
      <template v-slot:item="{ item }">
        {{ prettyTab(item) }}
      </template>
    </v-select>
    <v-row
      class="background"
      style="margin-top: 1em"
      align="stretch">
      <v-col
        v-if="!isMobile"
        cols="auto"
        class="sidebar"
        style="height: 100vh">
        <v-btn-toggle
          borderless
          overflow-auto>
          <div
            v-for="tab in tabs"
            :key="tab"
            style="width: 100%">
            <v-btn
              @click="updateTab(tab)"
              class="button--style"
              depressed
              tile
              block>
              {{ prettyTab(tab) }}
            </v-btn>
          </div>
        </v-btn-toggle>
      </v-col>
      <v-col
        :key="$route.params.tab"
        style="padding-left: 0; padding-bottom: 0; margin-bottom: 0; height: 100%"
        class="background">
        <h2>{{ prettyTab($route.params.tab) }}</h2>
        <div v-if="$route.params.tab == 'basic-skills'">
          <v-tabs
            v-model="abilityTab"
            class="character-tabs"
            dark
            color="black"
            centered>
            <v-tab>
              <h4>Maneuvers</h4>
            </v-tab>
            <v-tab>
              <h4>Attacks</h4>
            </v-tab>
            <v-tab>
              <h4>Gambits</h4>
            </v-tab>
            <v-tab> <h4>Reactions</h4> </v-tab>
            <v-tab> <h4>Stances</h4> </v-tab>
            <v-tab> <h4>Travel</h4> </v-tab>
            <v-tab> <h4>Camp</h4> </v-tab>
          </v-tabs>
          <v-tabs-items
            v-model="abilityTab"
            class="character-tab-content">
            <v-tab-item>
              <ability-tab
                abilityType="Maneuver"
                :character="character" />
            </v-tab-item>
            <v-tab-item>
              <ability-tab
                abilityType="Attack"
                :character="character" />
            </v-tab-item>
            <v-tab-item>
              <ability-tab
                abilityType="Gambit"
                :character="character" />
            </v-tab-item>
            <v-tab-item>
              <ability-tab
                abilityType="Reaction"
                :character="character" />
            </v-tab-item>
            <v-tab-item>
              <show-cards
                :inputs="basic_stances"
                :collapse="false"
                :cols="1"
            /></v-tab-item>
            <v-tab-item>
              <ability-tab
                abilityType="Travel"
                :character="character"
                :basic="true"
            /></v-tab-item>
            <v-tab-item>
              <ability-tab
                abilityType="Camp"
                :character="character"
            /></v-tab-item>
          </v-tabs-items>
        </div>
        <div
          class="character-tab-content"
          v-if="$route.params.tab == 'archetypes'"
          style="border-top: 2px solid black">
          <show-cards
            :inputs="archetypes"
            :collapse="false"
            :cols="1" />
        </div>

        <div v-if="$route.params.tab == 'spirit-disciplines'"><elemental-disciplines /></div>
        <div
          class="character-tab-content"
          style="border-top: 2px solid black"
          v-if="$route.params.tab == 'martial-disciplines'">
          <show-cards
            :inputs="martial_disciplines"
            :collapse="false"
            :cols="1" />
        </div>
        <div v-if="$route.params.tab == 'spirit-arts'"><elemental-arts /></div>
        <div
          class="character-tab-content"
          v-if="$route.params.tab == 'careers'"
          style="border-top: 2px solid black">
          <show-cards
            :inputs="careers"
            :collapse="false"
            :cols="1" />
        </div>
        <spirit-abilities v-if="$route.params.tab == 'spirit-customization'" />
        <div v-if="$route.params.tab == 'consumables'">
          <v-row
            class="select-bar"
            align="center">
            <v-col
              cols="12"
              style="padding-left: 3em; padding-right: 3em">
              <v-select
                v-model="selectedConsumables"
                :items="consumableCategories"
                attach
                label="Equipment Categories"
                multiple
                filled
                background-color="#dbd9d9e3" />
            </v-col>
          </v-row>
          <div class="character-tab-content">
            <show-cards
              :inputs="consumables"
              :collapse="false"
              :cols="1" />
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { Character } from '@/class'
import CustomButton from '@/components/Button.vue'
import ShowCards from '@/components/cards/ShowCards.vue'
import AbilityWidget from '@/components/AbilityWidget.vue'
import AbilityTab from '@/components/AbilityTab.vue'
import SpiritAbilities from '@/components/SpiritAbilities.vue'
import ElementalDisciplines from '@/components/ElementalDisciplines.vue'
import ElementalArts from '@/components/ElementalArts.vue'

export default Vue.extend({
  name: 'character-options',
  components: { AbilityTab, CustomButton, ShowCards, AbilityWidget, SpiritAbilities, ElementalArts, ElementalDisciplines },
  data() {
    return {
      selectedTab: 'basic-skills',
      tabs: ['basic-skills', 'archetypes', 'spirit-disciplines', 'martial-disciplines', 'careers', 'spirit-customization'],
      abilityTab: 0,
      character: new Character(),
    }
  },
  computed: {
    columns: function () {
      if (this.isMobile) return 1
      return 2
    },
    martial_disciplines: function () {
      var martialDiscs = this.$store.getters.getDisciplinesByType('Defender')
      martialDiscs = martialDiscs.concat(this.$store.getters.getDisciplinesByType('Supporter'))
      martialDiscs = martialDiscs.concat(this.$store.getters.getDisciplinesByType('Striker'))
      martialDiscs = martialDiscs.concat(this.$store.getters.getDisciplinesByType('Artillery'))
      return martialDiscs.sort((a, b) => a.Name.localeCompare(b.Name))
    },
    arts: function () {
      return this.$store.getters.getArts().sort((a, b) => a.Name.localeCompare(b.Name))
    },
    archetypes: function () {
      return this.$store.getters.getArchetypes().sort((a, b) => a.Name.localeCompare(b.Name))
    },
    careers: function () {
      return this.$store.getters.getCareers().sort((a, b) => a.Name.localeCompare(b.Name))
    },
    basic_stances() {
      return this.$store.getters.getStancesFromList(this.$store.getters.basicStances).sort((a, b) => a.Name.localeCompare(b.Name))
    },
    basic_abilities() {
      var arr = [
        { code: 'Maneuver', value: 0 },
        { code: 'Reaction', value: 0 },
        { code: 'Gambit', value: 0 },
      ]
      var order = ['Maneuver', 'Reaction', 'Gambit']
      var abilities = [
        ...this.$store.getters.getAbilitiesFromList(this.$store.getters.basicAbilities),
        ...this.$store.getters.getAbilitiesFromList(this.$store.getters.playerAbilities),
      ]
      abilities.sort((a, b) => {
        if (a.Type == b.Type) return a.Name.localeCompare(b.Name)
        return order.indexOf(a.Type) - order.indexOf(b.Type)
      })
      return abilities
    },
  },
})
</script>

<style scoped lang="scss">
.description-text {
  text-align: center;
  width: 100%;
}
.background {
  background: $color--background !important;
  height: 100%;
  margin: 0;
  padding: 0;
}
.character-tabs {
  font-family: $font--fancy;
  font-size: larger;
  border-top: $border--black-standard;
  border-radius: 0px;
}
.select-bar {
  background: #85704c !important;
  padding-left: 0em;
  margin-left: 0em;
}
.ability-box {
  margin-top: 0 !important;
  padding-top: 0 !important;
  margin: 0.5em;
  margin-bottom: 0em;
  border: $border--black-standard;
  background-color: $color--grey-light !important;
  height: 100%;
}
.character-tab-content {
  background-color: $color--grey-light !important;
  padding: 1em;
  border-bottom: $border--black-standard;
  border-left: $border--black-standard;
}
</style>
